import tauri from ".";

interface SyncStateResponse {
  running: boolean;
}

const DEFAULT_TIMEOUT_MS = 15_000;
const DEFAULT_POLL_INTERVAL_MS = 150;

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/**
 * Wait until the native sync worker reports idle.
 */
export async function waitForTauriSyncIdle(
  timeoutMs: number = DEFAULT_TIMEOUT_MS,
  pollIntervalMs: number = DEFAULT_POLL_INTERVAL_MS,
): Promise<void> {
  if (!tauri.enabled) return;

  const start = Date.now();
  while (true) {
    const state = await tauri.invoke<SyncStateResponse>("sync_state");
    if (!state.running) return;

    if (Date.now() - start >= timeoutMs) {
      throw new Error("Timed out waiting for native sync to become idle");
    }

    await sleep(pollIntervalMs);
  }
}

/**
 * Ensure local changes are uploaded before an edge-function call.
 */
export async function flushTauriSyncAndWait(
  timeoutMs: number = DEFAULT_TIMEOUT_MS,
  pollIntervalMs: number = DEFAULT_POLL_INTERVAL_MS,
): Promise<void> {
  if (!tauri.enabled) return;

  await waitForTauriSyncIdle(timeoutMs, pollIntervalMs);
  await tauri.performSync();
  await waitForTauriSyncIdle(timeoutMs, pollIntervalMs);
}
